/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
// import queryString from "query-string"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import SiharaisakiSearchModal from "../../../components/SearchModal/SiharaisakiSearchModal"
import CONSTANT from "../../../constant"
import { 区分分類コード } from "../../../constant/enum/codes"
import { setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import KubunService from "../../../service/master/kubun/kubunService"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"

import YosyaService from "../../../service/master/yosya/yosyaService"
import {
  TYosyaRegisterPostReq,
  TYosyaUpdatePutReq,
} from "../../../service/master/yosya/TYosya"

import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import {
  TYosyaRegisterPostReqSchema,
  TYosyaUpdatePutReqSchema,
} from "../../../service/master/yosya/yosyaSchema"
import { e支払先区分 } from "../../../constant/enum/master"
import { RootState } from "../../../globalStore/rootreducer"
import { メニューコード } from "../../../constant/menuCode"

const MasterYosyaRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.傭車マスタ登録
      )?.読み取り専用フラグ
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  // 傭車先検索
  const [is傭車先検索Modal, setIs傭車先検索Modal] = useState(false)
  //#region [state]

  // 表示項目のstate
  const [傭車先コード, set傭車先コード] = useState<string>()
  const [傭車先名, set傭車先名] = useState<string>()
  const [傭車先略称, set傭車先略称] = useState<string>()
  const [車番, set車番] = useState<string>()
  const [原動機有無フラグ, set原動機有無フラグ] = useState<0 | 1>()
  const [車種区分コード, set車種区分コード] = useState<string | null>()
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [乗務員名, set乗務員名] = useState<string>("")
  const [備考, set備考] = useState<string>("")
  const [最終更新日時, set最終更新日時] = useState<string>()
  const [最終更新ID, set最終更新ID] = useState<string>()

  //　エラー表示用フラグ
  const [isInvalid傭車先コード, setIsInvalid傭車先コード] = useState<boolean>()
  const [isInvalid車番, setIsInvalid車番] = useState<boolean>(false)
  const [, setIsInvalid原動機有無フラグ] = useState<boolean>(false)
  const [isInvalid車種区分コード, setIsInvalid車種区分コード] =
    useState<boolean>(false)
  const [isInvalid乗務員名, setIsInvalid乗務員名] = useState<boolean>(false)
  const [isInvalid備考, setIsInvalid備考] = useState<boolean>(false)
  const [, setIsInvalid更新日時] = useState<boolean>(false)

  //#region [comboboxState]

  // 車種区分
  const [車種区分ComboBox, set車種区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [車種区分IsLoadEnded, set車種区分IsLoadEnded] = useState<boolean>(false)

  //#endregion

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: number) => {
    const service = new YosyaService()

    try {
      const res = await service.get(id)
      if (res.data) {
        set傭車先コード(res.data.傭車先コード)
        set傭車先名(res.data.傭車先名)
        set傭車先略称(res.data.傭車先略称)
        set車番(res.data.車番)
        set原動機有無フラグ(res.data.原動機有無フラグ)
        set車種区分コード(res.data.車種区分コード)
        set乗務員名(res.data.乗務員名)
        set備考(res.data.備考)
        set最終更新ID(res.data.更新ユーザID.toString())
        set最終更新日時(res.data.更新日時 ? res.data.更新日時 : "")
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  const getPostReq = (): TYosyaRegisterPostReq => {
    return {
      傭車先コード: 傭車先コード ?? "",
      車番: 車番 ?? "",
      原動機有無フラグ: 原動機有無フラグ ? 1 : 0,
      車種区分コード: 車種区分コード ?? "",
      乗務員名: 乗務員名 ?? "",
      備考,
    }
  }

  const getPutReq = (): TYosyaUpdatePutReq => {
    return {
      傭車先コード: 傭車先コード ?? "",
      車番: 車番 ?? "",
      原動機有無フラグ: 原動機有無フラグ ? 1 : 0,
      車種区分コード: 車種区分コード ?? "",
      乗務員名: 乗務員名 ?? "",
      備考,
      更新日時: 最終更新日時 ?? "",
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    let data
    if (id) {
      schema = TYosyaUpdatePutReqSchema
      data = getPutReq()
    } else {
      schema = TYosyaRegisterPostReqSchema
      data = getPostReq()
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors
      const errorMessages: string[] = []
      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        errorMessages.push(
          ...errors.filter((e) => e.message != null).map((e) => e.message ?? "")
        )
      }
      disPatch(setWarningAlerts([...errorMessages]))
      return
    }

    setIsConfirmModalShow(true)
  }

  /**
   * 削除送信前
   */
  const beforeDeleteSubmit = () => {
    setIsConfirmDeleteModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid傭車先コード(errorProperties.includes("傭車先コード"))
    setIsInvalid車番(errorProperties.includes("車番"))
    setIsInvalid原動機有無フラグ(errorProperties.includes("原動機有無フラグ"))
    setIsInvalid車種区分コード(errorProperties.includes("車種コード"))
    setIsInvalid乗務員名(errorProperties.includes("乗務員名"))
    setIsInvalid備考(errorProperties.includes("備考"))
    setIsInvalid更新日時(errorProperties.includes("更新日時"))
  }
  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new YosyaService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, getPutReq())
      } else {
        res = await service.post(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`品名マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 削除
   */
  const doDelete = async () => {
    try {
      const service = new YosyaService()
      const res: TApiResponse<boolean> = await service.delete(id!, {
        更新日時: 最終更新日時!,
      })
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`積卸先マスタを削除しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  const update傭車先 = async (傭車先コード: string) => {
    set傭車先名("")
    set傭車先略称("")

    if (傭車先コード == null || wjCore.isNullOrWhiteSpace(傭車先コード)) return

    try {
      const res = await new SiharaisakiService().getList({
        支払先コード: 傭車先コード,
        支払先区分コード: e支払先区分.傭車先,
        完全一致フラグ: true,
      })

      if (res.data.length === 1) {
        set傭車先名(res.data[0].支払先名)
        set傭車先略称(res.data[0].支払先略称)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }
  //#endregion

  //#region [effect]

  //  傭車先請求idの切り替えに合わせて請求内訳の表示データを変更

  //初期設定
  useEffect(() => {
    if (車種区分ComboBox == null) return

    //画面全体ロック
    disPatch(画面ロック開始())

    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
      // id存在時はデータを取得し更新
      if (id) {
        getData(id)
          .then((res) => {
            if (res == null) return
          })
          .finally(() => {
            disPatch(画面ロック解除())
            // ファイルロード後、戻るボタン押下時に警告が出るように変更
            isPrompt.current = !読取専用フラグ
          })
      } else {
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      }
    })
  }, [車種区分ComboBox])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">傭車マスタ{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-75rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 傭車先 */}
                  <MasterRegisterFormRow label="傭車先" isRequired={true}>
                    <TextInput
                      style={{ width: "8.5rem" }}
                      id="傭車先コード"
                      isReadOnly={id != null}
                      name="傭車先コード"
                      value={傭車先コード}
                      setValue={(v) => {
                        set傭車先コード(v)
                      }}
                      maxLength={CONSTANT.validateConstant.LENGTH.支払先コード}
                      placeholder="傭車先CD"
                      className={isInvalid傭車先コード ? "is-error" : ""}
                      onBlur={(e) => {
                        id == null && update傭車先(傭車先コード ?? "")
                      }}></TextInput>
                    {id == null && (
                      <button
                        type="button"
                        className="icon-button"
                        onClick={() => {
                          setIs傭車先検索Modal(true)
                        }}>
                        <FontAwesomeIcon
                          className="icon-button-inner"
                          icon={faSearch}></FontAwesomeIcon>
                      </button>
                    )}
                    <TextInput
                      style={{ width: "20rem" }}
                      id="傭車先名"
                      name="傭車先名"
                      isReadOnly={true}
                      value={傭車先名}
                      setValue={() => {}}
                      maxLength={CONSTANT.validateConstant.LENGTH.一般名称}
                      placeholder="傭車先名"
                    />
                    <TextInput
                      style={{ width: "12rem" }}
                      id="傭車先略称"
                      name="傭車先略称"
                      isReadOnly={true}
                      value={傭車先略称}
                      setValue={() => {}}
                      maxLength={CONSTANT.validateConstant.LENGTH.一般名称}
                      placeholder="傭車先略称"
                    />
                  </MasterRegisterFormRow>
                  {/* 車番 */}
                  <MasterRegisterFormRow label="車番" isRequired={true}>
                    <TextInput
                      style={{ width: "30rem" }}
                      id="車番"
                      isReadOnly={id != null}
                      name="車番"
                      value={車番}
                      setValue={set車番}
                      maxLength={CONSTANT.validateConstant.LENGTH.一般名称}
                      placeholder="車番"
                      className={isInvalid車番 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 原動機有無フラグ */}
                  <MasterRegisterFormRow
                    label="原動機有無フラグ"
                    isRequired={false}>
                    <CheckInput
                      id="原動機有無フラグ"
                      type={"switch"}
                      label={""}
                      setValue={(v) => {
                        v === 1
                          ? set原動機有無フラグ(v)
                          : set原動機有無フラグ(0)
                      }}
                      value={原動機有無フラグ ?? 0}
                    />
                  </MasterRegisterFormRow>
                  {/* 車種区分 */}
                  <MasterRegisterFormRow label="車種" isRequired={true}>
                    <ComboBox.Kubun
                      placeholder="車種区分"
                      分類コード={区分分類コード.車輌.車種区分}
                      isLoadEnded={車種区分IsLoadEnded}
                      setIsLoadEnded={set車種区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired={true}
                      isEmpty={false}
                      itemsSource={区分ItemSource}
                      selectedValue={車種区分コード}
                      setSelectedValue={set車種区分コード}
                      ComboBox={車種区分ComboBox}
                      setComboBox={set車種区分ComboBox}
                      className={
                        isInvalid車種区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 乗務員名 */}
                  <MasterRegisterFormRow label="乗務員名" isRequired={false}>
                    <TextInput
                      id="乗務員名"
                      name="乗務員名"
                      value={乗務員名}
                      setValue={set乗務員名}
                      maxLength={100}
                      placeholder="乗務員名"
                      className={isInvalid乗務員名 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* 備考 */}
                  <MasterRegisterFormRow label="備考" isRequired={false}>
                    <TextAreaInput
                      className={["w-100", isInvalid備考 && "is-error"].join(
                        " "
                      )}
                      value={備考}
                      setValue={set備考}></TextAreaInput>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {id && (
          <>
            <Row>
              <Col>
                最終更新日時:
                {util.date.format(最終更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          <Col>
            {!読取専用フラグ && (
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                {id ? `更新` : `登録`}
              </Button>
            )}
            <Button
              size="lg"
              className="ms-2"
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
            {!読取専用フラグ && (
              <Button
                size="lg"
                className="ms-5"
                variant="caution"
                disabled={!id}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeDeleteSubmit()
                }}>
                削除
              </Button>
            )}
          </Col>
        </Row>
      </Container>
      {/* 傭車先検索 */}
      <SiharaisakiSearchModal
        size="lg"
        setIsShow={setIs傭車先検索Modal}
        isShow={is傭車先検索Modal}
        siharaisakiKubun={"傭車先"}
        setSiharaisaki={(支払先) => {
          set傭車先コード(支払先.支払先コード)
          set傭車先名(支払先.支払先名)
          set傭車先略称(支払先.支払先略称)
        }}></SiharaisakiSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={doDelete}>
        傭車マスタを削除しますか？
      </ConfirmModal>
    </>
  )
}

export default MasterYosyaRegister
